import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@nomoh-monorepo/data-access-auth';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-plano-expirado',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="plano-expirado-container">
      <div class="plano-expirado-card">
        <i class="pi pi-exclamation-triangle" style="font-size: 4rem; color: #f6ad55;"></i>
        <h1>{{ 'PLANO_EXPIRADO.TITULO' | translate }}</h1>
        <p>
          {{ 'PLANO_EXPIRADO.MENSAGEM' | translate }}
          <strong>{{ $sistemaNome() || ('PLANO_EXPIRADO.ESTE_SISTEMA' | translate) }}</strong>.
        </p>
        <p>{{ 'PLANO_EXPIRADO.CONTINUAR' | translate }}</p>

        <div class="actions">
          <button type="button" class="btn-renovar" (click)="renovarPlano()">
            <i class="pi pi-credit-card"></i>
            {{ 'PLANO_EXPIRADO.BOTOES.RENOVAR' | translate }}
          </button>

          <button type="button" class="btn-back" (click)="voltarLogin()">
            <i class="pi pi-arrow-left"></i>
            {{ 'PLANO_EXPIRADO.BOTOES.VOLTAR_LOGIN' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .plano-expirado-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 1rem;
      }

      .plano-expirado-card {
        background: white;
        border-radius: 1rem;
        padding: 3rem;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        text-align: center;
        max-width: 500px;
        width: 100%;
      }

      h1 {
        color: #2d3748;
        margin: 1rem 0;
        font-size: 2rem;
      }

      p {
        color: #718096;
        margin: 0.5rem 0;
        line-height: 1.6;
      }

      .actions {
        display: flex;
        gap: 1rem;
        justify-content: center;
        margin-top: 2rem;
      }

      button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 0.5rem;
        cursor: pointer;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.3s ease;
      }

      .btn-renovar {
        background: #3182ce;
        color: white;
      }

      .btn-renovar:hover {
        background: #2c5282;
      }

      .btn-back {
        background: #e2e8f0;
        color: #4a5568;
      }

      .btn-back:hover {
        background: #cbd5e0;
      }
    `,
  ],
})
export class PlanoExpiradoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);

  $sistemaNome = signal<string>('');

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.$sistemaNome.set(params.get('sistema') ?? '');
    });
  }

  renovarPlano(): void {
    const userId = this.authService.$user()?.id;
    if (userId) {
      this.router.navigate(['/minha-conta', userId]);
      return;
    }
    this.router.navigate(['/login']);
  }

  voltarLogin(): void {
    this.router.navigate(['/login']);
  }
}
